export default __webpack_public_path__ + "static/media/xing.980214fd.svg";